<template>
  <div>
    <div class="col-md-12">
      <div class="row col-md-12">
        <div class="title _mb col-md-6 no-padding">Registro de alterações</div>
      </div>
      <div v-if="loading" class="loadingbox">
        <spinner size="large"></spinner>
      </div>

      <div class="row col-md-12" v-if="!loading && changelogs?.length">
        <div
          v-for="changelog in changelogs"
          class="mb-3 pb-3"
          :key="changelog.id"
        >
          <h2 class="border-b border-gray-200 pb-2 text-base font-medium">
            {{ dataFormatada(changelog.data) }}
          </h2>
          <p class="text-base font-semibold mb-0">{{ changelog.titulo }}</p>
          <div
            v-html="renderizarMarkdown(changelog.descricao)"
            class="max-w-full mt-1 text-sm break-words markdown"
          ></div>
        </div>
      </div>
      <div class="row col-md-12" v-if="!loading && !changelogs?.length">
        Não há changelogs disponíveis no momento. Fique atento para futuras
        atualizações e melhorias em nossa API.
      </div>
    </div>
    <Paginator
      v-if="!loading && changelogs?.length"
      :pagina-atual="paginator.current_page"
      :ultima-pagina="paginator.total_pages"
      @get-page="getChangelogs"
    ></Paginator>
  </div>
</template>

<script>
import moment from "moment";
import usuarioApi from "../../api/usuario.js";
import Paginator from "../../admin/components/utils/Paginator";
import Spinner from "../../admin/components/utils/Spinner.vue";
import { getUrlParams, showHttpErrorMessage } from "../../admin/utils";
import markdownit from "markdown-it";

export default {
  name: "ChangelogsApi",
  components: {
    Paginator,
    Spinner,
  },
  data() {
    return {
      changelogs: [],
      paginator: [],
      paginacao: {
        pagina_atual: 1,
        ultima_pagina: 0,
      },
      links: [],
      loading: false,
    };
  },
  methods: {
    dataFormatada(data) {
      return moment(data, 'DD/MM/YYYY').locale("pt-br").format("D [de] MMMM [de] YYYY");
    },
    getChangelogs(params = null) {
      this.loading = true;
      this.changelogs = [];

      let page = params?.page || 1;

      usuarioApi
        .changelogs(page, params?.limit)
        .then(({ data }) => {
          this.loading = false;
          this.changelogs = data.items;
          this.paginator = data.paginator;
          this.links = data.links;

          this.paginacao.pagina_atual = page;
          this.paginacao.ultima_pagina = data.paginator.total_pages;
        })
        .catch((error) => {
          showHttpErrorMessage(error.response);
        });
    },
    renderizarMarkdown(texto) {
      const md = markdownit({
        html: true,
        linkify: true,
        breaks: true,
      });

      const texto_formatado = texto.replace(/<br>/g, "\n");

      return md.render(texto_formatado);
    },
  },
  created() {
    if (Object.keys(this.urlParams).length) {
     this.getChangelogs(this.urlParams);
    } else {
     this.getChangelogs();
    }
  },
  computed: {
    urlParams() {
      return getUrlParams();
    },
  },
};
</script>

<style scoped lang="stylus">
.title
  color #111827
  font-style normal
  font-weight 700
  font-size 30px
  line-height 44px
.no-padding
  padding-left 0px
  padding-right 0px
.select-width
  max-width 100px
.subtitulo
  font-style normal
  font-size 17px
  line-height 29px
  color #111827
  margin-top 15px
  margin-bottom 5px
.titulo
  border-bottom 1px solid #E5E7EB
.loadingbox
  position relative
  height 300px
.markdown :deep(a)
    color #056398
</style>
